
export const limitStringChars = (text, maxLength) => {
    const words = text.split(' ');

    if (text.length <= maxLength) {
      return text;
    }

    return words.reduce((acc, curr) => `${acc} ${curr}`.length <= maxLength ? `${acc} ${curr}` : acc);
};

export const safeLowerCase = text => (text || '').toLowerCase();
export const safeUpperCase = text => (text || '').toUpperCase();

export default {
  safeLowerCase,
  safeUpperCase,
  limitStringChars
};



// WEBPACK FOOTER //
// ../src/client/utils/textUtils.js